import {Button, Input, Typography} from 'antd';
import CardItem from './CardItem';
const {Text} = Typography;

const ShippingCharges = ({shippingCharges, updateShippingCharges, fetchShippingCharges, shippingAddress}) => {
  const shippingButtonDisabled = !shippingAddress.zip || !shippingAddress.province || !shippingAddress.country || !shippingAddress.city || !shippingAddress.address1;
  return (
    <CardItem>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
          <Text
            style={{
            fontSize: '12px',
            fontWeight: 700,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
            Shipping Charges
          </Text>
          <Button disabled={shippingButtonDisabled} type='link' onClick={fetchShippingCharges}>Fetch Charges</Button>
        </div>
      </div>
      <Input
        value={shippingCharges}
        onChange={e => {
          updateShippingCharges(e.target.value);
        }}
        min={0}
        type="number"
        placeholder="Enter Shipping Charges"
      />
    </CardItem>
  );
};

export default ShippingCharges;
